<div
  id="input"
  #editable
  contenteditable
  title="{{ 'Send Message' | translate }}"
  (paste)="_paste($event)"
  (beforeinput)="handleBeforeInput($event)"
  (input)="handleTextInput($event)"
  (keydown.control.b)="shortcutChangeSelection($event, 'bold')"
  (keydown.control.i)="shortcutChangeSelection($event, 'italic')"
  (keydown.control.s)="shortcutChangeSelection($event, 'strike')"
  (keydown.control.h)="shortcutChangeSelection($event, 'hidden')"
  (keydown.control.shift.c)="shortcutChangeSelection($event, 'code')"></div>
<div id="selectionEdit" #selectionEdit class="hidden">
  <div (click)="changeSelection('bold', true)">
    <fa-icon [icon]="faBold"></fa-icon>
  </div>
  <div (click)="changeSelection('italic', true)">
    <fa-icon [icon]="faItalic"></fa-icon>
  </div>
  <div (click)="changeSelection('strike', true)">
    <fa-icon [icon]="faStrikethrough"></fa-icon>
  </div>
  <div (click)="changeSelection('code', true)">
    <fa-icon [icon]="faCode"></fa-icon>
  </div>
  <div (click)="changeSelection('hidden', true)">
    <fa-icon [icon]="faEyeSlash"></fa-icon>
  </div>
</div>
